import { Component, OnInit } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { ApiServicesService } from '../services/api-services.service';
import * as RolesRouteMap from '../../../data/constants/roles';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateBeneComponent } from '../create-bene/create-bene.component';
import { SendInviteComponent } from '../send-invite/send-invite.component';
import { CompanyService } from 'src/app/services/company.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-undocumented-beneficiaries',
  templateUrl: './undocumented-beneficiaries.component.html',
  styleUrls: ['./undocumented-beneficiaries.component.scss']
})
export class UndocumentedBeneficiariesComponent implements OnInit {

  shownInterest: number = 0;
  poolCount: number = 0;
  totalElementCount: number = 0;
  pageSizeOptions = [25, 50, 100];
  pageIndex: number = 1;//default
  pageSize: number = 25;//default
  searchText = '';
  toggleStatus = 'INTEREST';
  cols: any[];
  searchSubscription: Subscription;
  interestedBeneficiaries;
  interestedBeneficiariesRecordCount = 0;
  beneficiariesPool;
  beneficiariesPoolRecordCount = 0;
  selectedBeneficiaryPoolArray= [];
  displayDetails :  boolean = false;
  beneficiaryId;

  filter = {
    visaType: []
  }  

  payload = {
    //companyId: parseInt(sessionStorage.getItem('companyId')),
    pageNumber: this.pageIndex,
    pageSize: this.pageSize,
    searchText: this.searchText,
    //startDate: null,
    //visaTypes: this.filter.visaType,
    //taskStatus: [],
  }

  constructor(private petitionerApiService: ApiServicesService,
    private router: Router,
    private companyApiService: CompanyService,
    private modalService: NgbModal,) { }

  ngOnInit() {

    this.cols = [
      { field: 'beneficaryName', header: 'Beneficiary Name' },
      { field: 'country', header: 'Country' },
      { field: 'citizenship', header: 'Citizenship' },
      { field: 'degree', header: 'Degree' }
    ];

    this.getBeneficiaryList();
  }

  getBeneficiaryList(){

    this.petitionerApiService.getUndocImmigrantListForPetitioner(parseInt(sessionStorage.getItem('companyId')), this.payload).subscribe(data => {
      if (data) {
          this.interestedBeneficiaries = data['interestedBeneficiaries'];
          this.beneficiariesPool = data['beneficiariesPool'];
          this.interestedBeneficiariesRecordCount = data['interestedBeneficiaries'] ? data['interestedBeneficiaries'].length : 0;
          this.beneficiariesPoolRecordCount = data['beneficiariesPool'] ? data['beneficiariesPool'].length : 0;
        } else {
          this.interestedBeneficiaries = [];
          this.beneficiariesPool = []
        }
      });
  }

  toggleMode(mode) {
    this.pageIndex = 0;
    this.payload.pageNumber = 1;
    this.payload.pageSize = 25;
    this.toggleStatus = mode;
    this.getBeneficiaryList();
  }

  resetSearch() {
    this.searchText = ''; //reset search
    this.pageIndex = 0;//reset search
    this.getBeneficiaryList();
  }

  paginationEvent(event) {
    this.payload.pageNumber = event.page + 1;
    this.payload.pageSize = event.rows;
    this.getBeneficiaryList();
  }

// IM-3352 (IM-3335) user story
openFormModal(inviteType, row?) {
  var modalRef;
  if (inviteType === 'Send Invite'){
   modalRef = this.modalService.open(CreateBeneComponent, { size: 'lg', backdrop: 'static', keyboard: false });
}
else{
   modalRef = this.modalService.open(SendInviteComponent, { size: 'lg', backdrop: 'static', keyboard: false }); 
}
let listCompany = [];
  this.companyApiService.getCompanyHierarchyById(parseInt(sessionStorage.getItem('companyId'))).subscribe(data => {
    listCompany = data;
  })
  modalRef.componentInstance.company = listCompany;
  if (row) {
    let rowArray = [];
    rowArray.push(row);
    modalRef.componentInstance.beneficiary = rowArray;
  }
  else{
    let ids = [];
    this.selectedBeneficiaryPoolArray.forEach(element => {
      ids.push(element['beneficiaryId']);
    });
    modalRef.componentInstance.beneficiary =ids; 
    }

}

beneficiaryDetails(item){
  this.displayDetails = true;
  this.beneficiaryId = item.beneficiaryId;
  //this.router.navigate([`../../../petitioner-landing/beneficiaries/undocumented/` + item.beneficiaryId]);
}

  // ngOnDestroy() {
  //   this.searchSubscription.unsubscribe();
  // }

}
